<template>
  <main class="page-wrap">
    <el-tabs class="tabs" v-model="currentTab" @tab-click="$_changeTab">
      <el-tab-pane label="组织映射" name="org">
        <mapping-org ref="org"></mapping-org>
      </el-tab-pane>
      <el-tab-pane label="用户映射" name="user" lazy>
        <mapping-user ref="user"></mapping-user>
      </el-tab-pane>
      <el-tab-pane label="定制枚举映射" name="enum" lazy>
        <mapping-enum ref="enum"></mapping-enum>
      </el-tab-pane>
    </el-tabs>
  </main>
</template>

<script>
import MappingOrg from "./org";
import MappingUser from "./user";
import MappingEnum from "./enum";

export default {
  name: "map-abutment",
  data() {
    return {
      currentTab: "org",
    };
  },
  methods: {
    $_changeTab(tab, event) {
      this.$nextTick(()=>{
        tab.$children[0]?.__resizeHanlder();
      })
    },
  },
  components: {
    MappingOrg,
    MappingUser,
    MappingEnum
  },
};
</script>
<style lang="scss" scoped>
.page-wrap {
  &.content-page {
    border: 0 !important;
  }
}
.tabs {
  position: relative;
  height: 100%;
  /deep/ .el-tabs__header {
    padding: 0;
    position: relative;
    margin: 0 0 20px;
    border-bottom: 1px solid #f2f2f2;
    .el-tabs__nav-wrap {
      overflow: hidden;
      margin-bottom: -1px;
      position: relative;
      padding-left: 18px;
    }
  }
  /deep/ .el-tabs__nav {
    float: left;
    position: relative;
    white-space: nowrap;
    transition: transform 0.3s;
    z-index: 2;
  }
  /deep/ .el-tabs__item {
    height: 40px;
    width: 120px;
    border-bottom: 2px solid transparent;
    margin-left: 6px;
    line-height: 40px;
    text-align: center;
    display: inline-block;
    list-style: none;
    font-size: 16px;
    font-weight: 500;
    color: #898989;
    position: relative;
    cursor: pointer;
    &.is-active {
      color: #384e8c;
      border-bottom-color: #384e8c;
    }
    &:focus,
    &:focus:active {
      outline: none;
    }
    &:nth-child(2) {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
  }

  /deep/ .el-tabs__content {
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding-top: 60px;
    overflow: hidden;
  }
  /deep/ .el-tab-pane {
    height: 100%;
  }
}
</style>
